import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password"
export default class extends Controller {
  static targets = ["password", "currentPassword", "currentPasswordGroup"]

  connect() {
    this.toggleCurrentPasswordRequirement()
  }

  toggleCurrentPasswordRequirement() {
    if (this.passwordTarget.value.length > 0) {
      this.currentPasswordTarget.setAttribute('required', 'true')
      this.currentPasswordGroupTarget.style.display = 'block'
    } else {
      this.currentPasswordTarget.removeAttribute('required')
    }
  }
}